<template>
  <span class="badge" :class="badgeClass"><slot></slot></span>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';

defineOptions({
  name: 'n-badge',
});

// Define props.
const props = defineProps({
  variant: {
    type: String as PropType<'primary' | 'secondary' | 'tertiary' | 'success' | 'danger' | 'default'>,
    default: 'primary',
  },
});

const badgeClass = computed(() => ({
  'badge--primary': props.variant === 'primary',
  'badge--secondary': props.variant === 'secondary',
  'badge--tertiary': props.variant === 'tertiary',
  'badge--success': props.variant === 'success',
  'badge--danger': props.variant === 'danger',
}));
</script>

<style lang="scss" scoped>
@use '../../../styles/colours' as *;
.badge {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 0.375em;
  color: #4a4a4a;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
  &.badge--primary {
    background: colourScheme('deep-sea');
    color: colourScheme('light');
  }
  &.badge--secondary {
    background: colourScheme('jonquil');
    color: colourScheme('body-text');
  }
  &.badge--tertiary {
    background: colourScheme('salmon');
    color: colourScheme('light');
  }
  &.badge--success {
    // This one doesn't meet colour contrast guidelines
    background: colourScheme('success');
    color: colourScheme('light');
  }
  &.badge--success {
    background: colourScheme('success');
    color: colourScheme('light');
  }
  &.badge--danger {
    background: colourScheme('danger');
    color: colourScheme('light');
  }
}
</style>
